import { BaseModel } from "model/BaseModel";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Usuario from "model/administracao/cadastro/Usuario";
import ItemNotaFiscalEntrada from "./ItemNotaFiscalEntrada";
import Transacao from "./Transacao";
import Arquivo from "model/arquivo/Arquivo";

export default class NotaFiscalEntrada implements BaseModel {

    id: number;
    codigo: string | null;
    numero: number;
    fornecedor: Pessoa;
    dataRecebimento: Date | null;
    usuario: Usuario;
    itens: Array<ItemNotaFiscalEntrada>;
    status: string;
    transacao: Transacao;
    arquivos: Arquivo[];

    constructor(
        id = 0,
        codigo = null,
        numero = 0,
        fornecedor = new Pessoa(),
        dataRecebimento = null,
        usuario = new Usuario(),
        itens = new Array<ItemNotaFiscalEntrada>(),
        status = 'DIGITADA',
        transacao = new Transacao(),
        arquivos = []
    ) {
        this.id = id;
        this.codigo = codigo;
        this.numero = numero;
        this.fornecedor = fornecedor;
        this.dataRecebimento = dataRecebimento;
        this.usuario = usuario;
        this.itens = itens;
        this.status = status;
        this.transacao = transacao;
        this.arquivos = arquivos;
    }
}